import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  TaxListReq,
  TaxListRes,
  CreateTaxReq,
  ActionTaxRes,
  UpdateTaxReq,
  DeleteTaxReq,
  TaxDetailReq,
  GetMerchantTaxReq,
  GetMerchantTaxRes,
  UpdateMerchantTaxReq,
  TaxDetailRes,
  CreateTaxSupplierReq,
  GetAllCustomerTaxReq,
  GetAllCustomerTaxRes,
} from './types'

export const getTaxListAction = createAsyncAction(
  'TAX/GET_TAX_LIST_REQ',
  'TAX/GET_TAX_LIST_SUCCESS',
  'TAX/GET_TAX_LIST_FAILURE',
)<TaxListReq, TaxListRes, Error>()

export const getTaxDetailAction = createAsyncAction(
  'TAX/GET_TAX_DETAIL_REQ',
  'TAX/GET_TAX_DETAIL_SUCCESS',
  'TAX/GET_TAX_DETAIL_FAILURE',
)<TaxDetailReq, TaxDetailRes, Error>()

export const createTaxAction = createAsyncAction(
  'TAX/CREATE_TAX_REQ',
  'TAX/CREATE_TAX_SUCCESS',
  'TAX/CREATE_TAX_FAILURE',
)<CreateTaxReq, ActionTaxRes, Error>()

export const createTaxSupplierAction = createAsyncAction(
  'TAX/CREATE_TAX_SUP_REQ',
  'TAX/CREATE_TAX__SUP_SUCCESS',
  'TAX/CREATE_TAX_SUP_FAILURE',
)<CreateTaxSupplierReq, ActionTaxRes, Error>()

export const updateTaxAction = createAsyncAction(
  'TAX/UPDATE_TAX_REQ',
  'TAX/UPDATE_TAX_SUCCESS',
  'TAX/UPDATE_TAX_FAILURE',
)<UpdateTaxReq, ActionTaxRes, Error>()

export const deleteTaxAction = createAsyncAction(
  'TAX/DELETE_TAX_REQ',
  'TAX/DELETE_TAX_SUCCESS',
  'TAX/DELETE_TAX_FAILURE',
)<DeleteTaxReq, ActionTaxRes, Error>()

export const getMerchantTaxAction = createAsyncAction(
  'TAX/GET_MERCHANT_TAX_REQ',
  'TAX/GET_MERCHANT_TAX_SUCCESS',
  'TAX/GET_MERCHANT_TAX_FAILURE',
)<GetMerchantTaxReq, GetMerchantTaxRes, Error>()

export const updateMerchantTaxAction = createAsyncAction(
  'TAX/UPDATE_MERCHANT_TAX_REQ',
  'TAX/UPDATE_MERCHANT_SUCCESS',
  'TAX/UPDATE_MERCHANT_FAILURE',
)<UpdateMerchantTaxReq, ActionTaxRes, Error>()

export const getAllCustomerTaxListAction = createAsyncAction(
  'TAX/GET_ALL_CUS_TAX_LIST_REQ',
  'TAX/GET_ALL_CUS_TAX_LIST_SUCCESS',
  'TAX/GET_ALL_CUS_TAX_LIST_FAILURE',
)<GetAllCustomerTaxReq, GetAllCustomerTaxRes, Error>()

export const clearEventAction = createStandardAction('TAX/CLEAR_EVENT')<void>()
